import { cn } from "@/lib/utils";

const LEGAL_ENTITY_NAME = "AVIE-CORDER MEDIA PRIVATE LIMITED";

export function LegalFooter({ className, variant = "minimal" }) {
  const year = new Date().getFullYear();

  if (variant === "minimal") {
    return (
      <footer className={cn("py-4 text-center text-xs text-stone-500", className)}>
        &copy; {year} {LEGAL_ENTITY_NAME}. All rights reserved.
      </footer>
    );
  }

  return (
    <footer className={cn("py-6 text-center text-xs font-bold uppercase tracking-widest text-stone-500", className)}>
      &copy; {year} {LEGAL_ENTITY_NAME}. All rights reserved.
    </footer>
  );
}

export { LEGAL_ENTITY_NAME };
